import breakpoints from '../breakpoints';
import { colors } from '../constants';
const styleOverrides = {
  root: {
    textTransform: 'none',
    minWidth: 'unset',
    minHeight: 'unset',
    fontSize: 14,
    padding: '10px 4px',
    marginRight: 20,
    [breakpoints.up('md')]: {
      minWidth: 'unset',
      marginRight: 60,
      fontSize: 20,
      padding: '12px 4px'
    },
    [breakpoints.up('lg')]: {
      fontSize: 20
    },
    '&:last-child': {
      marginRight: 0
    }
  },
  textColorPrimary: {
    color: colors.oriGrey[600],
    '&.Mui-selected': {
      color: colors.text.primary
    }
  }
};
const defaultProps = {
  disableRipple: true
};
export default {
  styleOverrides,
  defaultProps
};